import Button from '@hellodarwin/core/lib/components/common/button';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { Screen } from './styles';

interface InvitationErrorScreenProps {
  errorCode: number;
  onContinue: () => void;
}

const InvitationErrorScreen = ({
  errorCode,
  onContinue,
}: InvitationErrorScreenProps) => {
  const { t } = useTranslations();
  return (
    <Screen>
      <Typography.Title level={2} elementTheme="h2">
        {t(`errors|${errorCode}.message`)}
      </Typography.Title>
      <Typography.Paragraph>
        {t(`errors|${errorCode}.description`)}
      </Typography.Paragraph>
      <Button onClick={onContinue}>
        {t('common|invitation.continueToAccount')}
      </Button>
    </Screen>
  );
};

export default InvitationErrorScreen;
